import {
  BatchStatisticsConditionListItem,
  BatchStatisticsConditionListItemFromJSON
} from '@/api/models/batch/BatchStatisticsConditionListItem'

export interface BatchStatisticsPageLoadResult {
  items: BatchStatisticsConditionListItem
}

export function BatchStatisticsPageLoadResultFromJSON(
  json: any
): BatchStatisticsPageLoadResult {
  console.warn(json)

  return {
    items: BatchStatisticsConditionListItemFromJSON(json)
  }
}
